var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('h4',[_vm._v("Доп. материал")]),_c('materials',{attrs:{"id":_vm.id}})],1),_c('hr'),_c('Div',[_c('h4',[_vm._v("Темы")]),_c('themes',{attrs:{"id":_vm.id}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }